import MobileMenu, { MobileMenuCSS } from "./MobileMenu";
import { supabase } from "./supabaseClient";
import { useState, useRef, useEffect } from "react";

// ─── LEGISLATOR DATA ──────────────────────────────────────────────────────────

export const SENATE_MEMBERS = [
  {id:"s1",name:"Erika Geiss",party:"D",district:1,region:"Taylor/Downriver",ideology:2,keyIssues:["Education","Labor","Civil rights"]},
  {id:"s2",name:"Sylvia Santana",party:"D",district:2,region:"Detroit",ideology:2,keyIssues:["Healthcare","Detroit","Housing"]},
  {id:"s3",name:"Stephanie Chang",party:"D",district:3,region:"Detroit",ideology:2,keyIssues:["Environment","Criminal justice","Energy"]},
  {id:"s4",name:"Darrin Camilleri",party:"D",district:4,region:"Brownstown",ideology:4,keyIssues:["Labor","Education","Working families"]},
  {id:"s5",name:"Dayna Polehanki",party:"D",district:5,region:"Livonia/Westland",ideology:5,keyIssues:["Education","Local gov","Women's rights"]},
  {id:"s6",name:"Mary Cavanagh",party:"D",district:6,region:"Redford",ideology:4,keyIssues:["Public safety","Consumer protection"]},
  {id:"s7",name:"Jeremy Moss",party:"D",district:7,region:"Southfield",ideology:3,keyIssues:["LGBTQ+ rights","Tax policy"]},
  {id:"s8",name:"Mallory McMorrow",party:"D",district:8,region:"Royal Oak/Troy",ideology:4,keyIssues:["Infrastructure","Transit","Tech"]},
  {id:"s9",name:"Michael Webber",party:"R",district:9,region:"Rochester Hills",ideology:7,keyIssues:["Small business","Lower taxes"]},
  {id:"s10",name:"Paul Wojno",party:"D",district:10,region:"Warren",ideology:4,keyIssues:["Labor","Manufacturing"]},
  {id:"s11",name:"Veronica Klinefelt",party:"D",district:11,region:"Eastpointe",ideology:5,keyIssues:["Infrastructure","Local gov"]},
  {id:"s12",name:"Kevin Hertel",party:"D",district:12,region:"St. Clair Shores",ideology:5,keyIssues:["Transportation","Criminal justice"]},
  {id:"s13",name:"Rosemary Bayer",party:"D",district:13,region:"Beverly Hills",ideology:4,keyIssues:["Environment","Water quality"]},
  {id:"s14",name:"Sue Shink",party:"D",district:14,region:"Ann Arbor area",ideology:3,keyIssues:["Environmental law","Clean water"]},
  {id:"s15",name:"Jeff Irwin",party:"D",district:15,region:"Ann Arbor",ideology:2,keyIssues:["Higher education","Tax policy"]},
  {id:"s16",name:"Joseph Bellino",party:"R",district:16,region:"Monroe",ideology:7,keyIssues:["Transportation","Economic dev"]},
  {id:"s17",name:"Jonathan Lindsey",party:"R",district:17,region:"Jackson area",ideology:8,keyIssues:["Agriculture","Rural issues"]},
  {id:"s18",name:"Thomas Albert",party:"R",district:18,region:"Lowell/Ionia",ideology:8,keyIssues:["Fiscal responsibility","Budget"]},
  {id:"s19",name:"Sean McCann",party:"D",district:19,region:"Kalamazoo",ideology:4,keyIssues:["Healthcare","Appropriations"]},
  {id:"s20",name:"Aric Nesbitt",party:"R",district:20,region:"Porter Township",ideology:9,keyIssues:["Deregulation","Tax cuts"]},
  {id:"s21",name:"Sarah Anthony",party:"D",district:21,region:"Lansing",ideology:3,keyIssues:["State budget","Community investment"]},
  {id:"s22",name:"Lana Theis",party:"R",district:22,region:"Brighton",ideology:8,keyIssues:["School choice","Parental rights"]},
  {id:"s23",name:"Jim Runestad",party:"R",district:23,region:"White Lake",ideology:8,keyIssues:["Criminal justice","Deregulation"]},
  {id:"s24",name:"Ruth Johnson",party:"R",district:24,region:"Holly/Clarkston",ideology:7,keyIssues:["Election integrity","Local gov"]},
  {id:"s25",name:"Dan Lauwers",party:"R",district:25,region:"Thumb/Sanilac",ideology:8,keyIssues:["Agriculture","Natural resources"]},
  {id:"s26",name:"Kevin Daley",party:"R",district:26,region:"Lapeer/Tuscola",ideology:8,keyIssues:["Agriculture","Rural roads"]},
  {id:"s27",name:"John Cherry",party:"D",district:27,region:"Flint/Genesee",ideology:4,keyIssues:["Flint recovery","Economic dev"]},
  {id:"s28",name:"Sam Singh",party:"D",district:28,region:"East Lansing",ideology:4,keyIssues:["University funding","Tech economy"]},
  {id:"s29",name:"Winnie Brinks",party:"D",district:29,region:"Grand Rapids",ideology:4,keyIssues:["Budget","Healthcare","Urban investment"]},
  {id:"s30",name:"Mark Huizenga",party:"R",district:30,region:"Walker/Wyoming",ideology:7,keyIssues:["Fiscal policy","Insurance","Business"]},
  {id:"s31",name:"Roger Victory",party:"R",district:31,region:"W. Michigan/Ottawa",ideology:8,keyIssues:["Agriculture","Water rights"]},
  {id:"s32",name:"Jon Bumstead",party:"R",district:32,region:"Newaygo/Muskegon",ideology:7,keyIssues:["Natural resources","Fishing"]},
  {id:"s33",name:"Rick Outman",party:"R",district:33,region:"Six Lakes/Montcalm",ideology:9,keyIssues:["Deregulation","Agriculture"]},
  {id:"s34",name:"Roger Hauck",party:"R",district:34,region:"Isabella/Clare",ideology:8,keyIssues:["Energy policy","Natural resources"]},
  {id:"s36",name:"Michele Hoitenga",party:"R",district:36,region:"Manton/Cadillac",ideology:8,keyIssues:["Healthcare freedom","Parental rights"]},
  {id:"s37",name:"John Damoose",party:"R",district:37,region:"Harbor Springs",ideology:7,keyIssues:["Tourism","Northern MI economy"]},
  {id:"s38",name:"Ed McBroom",party:"R",district:38,region:"Upper Peninsula",ideology:8,keyIssues:["Mining","UP economy"]},
];

export const HOUSE_MEMBERS = [
  {id:"h1",name:"Tyrone Carter",party:"D",district:1,region:"Wayne",ideology:2},{id:"h2",name:"Tullio Liberati",party:"D",district:2,region:"Wayne",ideology:3},{id:"h3",name:"Alabas Farhat",party:"D",district:3,region:"Wayne",ideology:3},{id:"h4",name:"Karen Whitsett",party:"D",district:4,region:"Wayne",ideology:5},{id:"h5",name:"Regina Weiss",party:"D",district:5,region:"Oakland/Wayne",ideology:3},{id:"h6",name:"Natalie Price",party:"D",district:6,region:"Oakland/Wayne",ideology:3},{id:"h7",name:"Tonya Myers Phillips",party:"D",district:7,region:"Oakland/Wayne",ideology:3},{id:"h8",name:"Helena Scott",party:"D",district:8,region:"Oakland/Wayne",ideology:3},{id:"h9",name:"Joe Tate",party:"D",district:9,region:"Wayne",ideology:4},{id:"h10",name:"Veronica Paiz",party:"D",district:10,region:"Macomb/Wayne",ideology:4},{id:"h11",name:"Donavan McKinney",party:"D",district:11,region:"Macomb/Wayne",ideology:4},{id:"h12",name:"Kimberly Edwards",party:"D",district:12,region:"Macomb/Wayne",ideology:4},{id:"h13",name:"Mai Xiong",party:"D",district:13,region:"Macomb/Wayne",ideology:4},{id:"h14",name:"Mike McFall",party:"D",district:14,region:"Macomb/Wayne",ideology:4},{id:"h15",name:"Erin Byrnes",party:"D",district:15,region:"Wayne",ideology:4},{id:"h16",name:"Stephanie Young",party:"D",district:16,region:"Wayne",ideology:3},{id:"h17",name:"Laurie Pohutsky",party:"D",district:17,region:"Wayne",ideology:3},{id:"h18",name:"Jason Hoskins",party:"D",district:18,region:"Oakland",ideology:4},{id:"h19",name:"Samantha Steckloff",party:"D",district:19,region:"Oakland",ideology:4},{id:"h20",name:"Noah Arbit",party:"D",district:20,region:"Oakland",ideology:3},{id:"h21",name:"Kelly Breen",party:"D",district:21,region:"Oakland",ideology:4},{id:"h22",name:"Matt Koleszar",party:"D",district:22,region:"Wayne",ideology:4},{id:"h23",name:"Jason Morgan",party:"D",district:23,region:"Oakland/Washtenaw",ideology:4},{id:"h24",name:"Ranjeev Puri",party:"D",district:24,region:"Wayne",ideology:3},{id:"h25",name:"Peter Herzberg",party:"D",district:25,region:"Wayne",ideology:4},{id:"h26",name:"Dylan Wegela",party:"D",district:26,region:"Wayne",ideology:4},{id:"h27",name:"Rylee Linting",party:"R",district:27,region:"Wayne",ideology:7},{id:"h28",name:"Jamie Thompson",party:"R",district:28,region:"Monroe/Wayne",ideology:7},{id:"h29",name:"James DeSana",party:"R",district:29,region:"Monroe/Wayne",ideology:8},{id:"h30",name:"William Bruck",party:"R",district:30,region:"Lenawee/Monroe",ideology:7},{id:"h31",name:"Reggie Miller",party:"D",district:31,region:"Lenawee/Monroe",ideology:5},{id:"h32",name:"Jimmie Wilson Jr.",party:"D",district:32,region:"Washtenaw",ideology:4},{id:"h33",name:"Morgan Foreman",party:"D",district:33,region:"Washtenaw",ideology:4},{id:"h34",name:"Nancy Jenkins-Arno",party:"R",district:34,region:"Lenawee",ideology:8},{id:"h35",name:"Jennifer Wortz",party:"R",district:35,region:"Branch/Hillsdale",ideology:8},{id:"h36",name:"Steve Carra",party:"R",district:36,region:"Cass/St. Joseph",ideology:9},{id:"h37",name:"Brad Paquette",party:"R",district:37,region:"Berrien/Cass",ideology:8},{id:"h38",name:"Joey Andrews",party:"D",district:38,region:"Allegan/Berrien",ideology:5},{id:"h39",name:"Pauline Wendzel",party:"R",district:39,region:"Allegan/Berrien",ideology:8},{id:"h40",name:"Matthew Longjohn",party:"D",district:40,region:"Kalamazoo",ideology:4},{id:"h41",name:"Julie Rogers",party:"D",district:41,region:"Kalamazoo",ideology:4},{id:"h42",name:"Matt Hall",party:"R",district:42,region:"Allegan/Kalamazoo",ideology:7},{id:"h43",name:"Rachelle Smit",party:"R",district:43,region:"Allegan/Barry",ideology:7},{id:"h44",name:"Steve Frisbie",party:"R",district:44,region:"Calhoun",ideology:7},{id:"h45",name:"Sarah Lightner",party:"R",district:45,region:"Calhoun/Kalamazoo",ideology:8},{id:"h46",name:"Kathy Schmaltz",party:"R",district:46,region:"Jackson/Washtenaw",ideology:7},{id:"h47",name:"Carrie Rheingans",party:"D",district:47,region:"Jackson/Washtenaw",ideology:4},{id:"h48",name:"Jennifer Conlin",party:"D",district:48,region:"Jackson/Livingston",ideology:5},{id:"h49",name:"Ann Bollin",party:"R",district:49,region:"Livingston/Oakland",ideology:8},{id:"h50",name:"Jason Woolford",party:"R",district:50,region:"Livingston",ideology:8},{id:"h51",name:"Matt Maddock",party:"R",district:51,region:"Oakland",ideology:9},{id:"h52",name:"Mike Harris",party:"R",district:52,region:"Oakland",ideology:7},{id:"h53",name:"Brenda Carter",party:"D",district:53,region:"Oakland",ideology:4},{id:"h54",name:"Donni Steele",party:"R",district:54,region:"Oakland",ideology:7},{id:"h55",name:"Mark Tisdel",party:"R",district:55,region:"Oakland",ideology:7},{id:"h56",name:"Sharon MacDonell",party:"D",district:56,region:"Oakland",ideology:4},{id:"h57",name:"Thomas Kuhn",party:"R",district:57,region:"Macomb/Oakland",ideology:7},{id:"h58",name:"Ron Robinson",party:"R",district:58,region:"Macomb",ideology:8},{id:"h59",name:"Doug Wozniak",party:"R",district:59,region:"Macomb",ideology:8},{id:"h60",name:"Joseph Aragona",party:"R",district:60,region:"Macomb",ideology:7},{id:"h61",name:"Denise Mentzer",party:"D",district:61,region:"Macomb",ideology:5},{id:"h62",name:"Alicia St. Germaine",party:"R",district:62,region:"Macomb",ideology:7},{id:"h63",name:"Jay DeBoyer",party:"R",district:63,region:"Macomb/St. Clair",ideology:8},{id:"h64",name:"Joseph Pavlov",party:"R",district:64,region:"Sanilac/St. Clair",ideology:8},{id:"h65",name:"Jaime Greene",party:"R",district:65,region:"Lapeer/Macomb",ideology:7},{id:"h66",name:"Josh Schriver",party:"R",district:66,region:"Macomb/Oakland",ideology:9},{id:"h67",name:"Phil Green",party:"R",district:67,region:"Genesee/Lapeer",ideology:8},{id:"h68",name:"David Martin",party:"R",district:68,region:"Genesee/Oakland",ideology:7},{id:"h69",name:"Jasper Martus",party:"D",district:69,region:"Genesee",ideology:4},{id:"h70",name:"Cynthia Neeley",party:"D",district:70,region:"Genesee",ideology:4},{id:"h71",name:"Brian BeGole",party:"R",district:71,region:"Genesee/Saginaw",ideology:7},{id:"h72",name:"Mike Mueller",party:"R",district:72,region:"Genesee/Livingston",ideology:7},{id:"h73",name:"Julie Brixie",party:"D",district:73,region:"Ingham",ideology:3},{id:"h74",name:"Kara Hope",party:"D",district:74,region:"Ingham",ideology:3},{id:"h75",name:"Penelope Tsernoglou",party:"D",district:75,region:"Clinton/Ingham",ideology:4},{id:"h76",name:"Angela Witwer",party:"D",district:76,region:"Eaton",ideology:4},{id:"h77",name:"Emily Dievendorf",party:"D",district:77,region:"Clinton/Eaton",ideology:3},{id:"h78",name:"Gina Johnsen",party:"R",district:78,region:"Barry/Eaton/Ionia",ideology:7},{id:"h79",name:"Angela Rigas",party:"R",district:79,region:"Allegan/Barry/Kent",ideology:8},{id:"h80",name:"Phil Skaggs",party:"D",district:80,region:"Kent",ideology:4},{id:"h81",name:"Stephen Wooden",party:"D",district:81,region:"Kent",ideology:4},{id:"h82",name:"Kristian Grant",party:"D",district:82,region:"Kent",ideology:4},{id:"h83",name:"John Fitzgerald",party:"D",district:83,region:"Kent",ideology:4},{id:"h84",name:"Carol Glanville",party:"D",district:84,region:"Kent",ideology:4},{id:"h85",name:"Bradley Slagh",party:"R",district:85,region:"Ottawa",ideology:8},{id:"h86",name:"Nancy De Boer",party:"R",district:86,region:"Allegan/Ottawa",ideology:7},{id:"h87",name:"Will Snyder",party:"D",district:87,region:"Muskegon",ideology:4},{id:"h88",name:"Greg VanWoerkom",party:"R",district:88,region:"Muskegon/Ottawa",ideology:8},{id:"h89",name:"Luke Meerman",party:"R",district:89,region:"Kent/Muskegon",ideology:8},{id:"h90",name:"Bryan Posthumus",party:"R",district:90,region:"Kent",ideology:8},{id:"h91",name:"Pat Outman",party:"R",district:91,region:"Ionia/Kent",ideology:8},{id:"h92",name:"Jerry Neyer",party:"R",district:92,region:"Gratiot/Isabella",ideology:8},{id:"h93",name:"Tim Kelly",party:"R",district:93,region:"Clinton/Gratiot",ideology:8},{id:"h94",name:"Amos O'Neal",party:"D",district:94,region:"Saginaw",ideology:4},{id:"h95",name:"Bill G. Schuette",party:"R",district:95,region:"Gladwin/Midland",ideology:8},{id:"h96",name:"Timothy Beson",party:"R",district:96,region:"Bay",ideology:7},{id:"h97",name:"Matthew Bierlein",party:"R",district:97,region:"Bay/Genesee",ideology:7},{id:"h98",name:"Gregory Alexander",party:"R",district:98,region:"Huron/Lapeer",ideology:8},{id:"h99",name:"Mike Hoadley",party:"R",district:99,region:"Arenac/Bay/Clare",ideology:7},{id:"h100",name:"Tom Kunse",party:"R",district:100,region:"Clare/Lake",ideology:8},{id:"h101",name:"Joseph Fox",party:"R",district:101,region:"Lake/Mason",ideology:8},{id:"h102",name:"Curt VanderWall",party:"R",district:102,region:"Manistee/Mason",ideology:8},{id:"h103",name:"Betsy Coffia",party:"D",district:103,region:"Benzie/Grand Traverse",ideology:4},{id:"h104",name:"John Roth",party:"R",district:104,region:"Antrim/Grand Traverse",ideology:7},{id:"h105",name:"Ken Borton",party:"R",district:105,region:"Antrim/Crawford",ideology:8},{id:"h106",name:"Cam Cavitt",party:"R",district:106,region:"Alcona/Alpena",ideology:8},{id:"h107",name:"Parker Fairbairn",party:"R",district:107,region:"Charlevoix/Emmet",ideology:7},{id:"h108",name:"David Prestin",party:"R",district:108,region:"Chippewa/Delta",ideology:8},{id:"h109",name:"Karl Bohnak",party:"R",district:109,region:"Alger/Dickinson",ideology:8},{id:"h110",name:"Gregory Markkanen",party:"R",district:110,region:"Dickinson/Gogebic",ideology:9},
];

// ─── AI SYSTEM PROMPT ─────────────────────────────────────────────────────────


// ─── LEGISCAN INTEGRATION ─────────────────────────────────────────────────────
// Fetches real voting history for all legislators before simulation runs.
// Attribution: Data provided by LegiScan (legiscan.com)

const FV_PROXY = "https://legisim-server.onrender.com";

function normFVName(name) {
  return name.toLowerCase().replace(/[^a-z ]/g, "").trim();
}

async function getFVNameMap() {
  const cached = sessionStorage.getItem("wc_namemap");
  if (cached) return JSON.parse(cached);
  try {
    const res = await fetch(FV_PROXY + "/api/legiscan/nametopeople");
    if (!res.ok) return {};
    const data = await res.json();
    const map = data.nameMap || {};
    sessionStorage.setItem("wc_namemap", JSON.stringify(map));
    return map;
  } catch(e) { return {}; }
}

async function fetchFVMemberVotes(name) {
  const cacheKey = "wc_votes_" + normFVName(name).replace(/ /g, "_");
  const cached = sessionStorage.getItem(cacheKey);
  if (cached) return JSON.parse(cached);
  try {
    const res = await fetch(FV_PROXY + "/api/db/personvotes?name=" + encodeURIComponent(name));
    if (!res.ok) return [];
    const data = await res.json();
    const votes = data.votes || [];
    sessionStorage.setItem(cacheKey, JSON.stringify(votes));
    return votes;
  } catch(e) { return []; }
}

export async function fetchAllFVMemberVotes(members) {
  const results = {};
  await Promise.all(members.map(async function(m) {
    const votes = await fetchFVMemberVotes(m.name);
    if (votes.length > 0) {
      const yea = votes.filter(function(v) { return v.vote === 1; }).length;
      const nay = votes.filter(function(v) { return v.vote === 2; }).length;
      const total = yea + nay;
      results[m.id] = {
        yeaRate: total > 0 ? Math.round(yea / total * 100) : 50,
        totalVotes: total,
      };
    }
  }));
  return results;
}

export function formatFVVotingStats(memberVotes, members) {
  const lines = [];
  members.forEach(function(m) {
    const stats = memberVotes[m.id];
    if (stats) {
      lines.push(m.id + "|yea_rate:" + stats.yeaRate + "%|votes:" + stats.totalVotes);
    }
  });
  if (lines.length === 0) return "";
  return "\nVERIFIED VOTING STATS (LegiScan 2025-2026):\n" + lines.join("\n");
}

export const buildPrompt = (chamber, votingStats) => {
  votingStats = votingStats || "";
  const members = chamber === "Senate" ? SENATE_MEMBERS : HOUSE_MEMBERS;
  const majority = chamber === "Senate" ? "Democrats hold majority 19-18" : "Republicans hold majority 58-52";
  const passThreshold = chamber === "Senate" ? "19 votes" : "56 votes";
  const leadership = chamber === "Senate"
    ? "Majority Leader: Winnie Brinks D-29 | Minority Leader: Aric Nesbitt R-20 | Pro Tem: Jeremy Moss D-7"
    : "Speaker: Matt Hall R-42 | Majority Leader: Bryan Posthumus R-90 | Minority Leader: Ranjeev Puri D-24";

  const memberList = members.map(m =>
    `${m.id}|${m.party}-${m.district}|${m.name}|ideology:${m.ideology}/10|${m.region}|${(m.keyIssues||[]).join(", ")}`
  ).join("\n");

  return `You are Floor Vote Simulator for the Michigan ${chamber}.
${majority} | Pass requires: ${passThreshold} | ${leadership}

MEMBERS:
${memberList}

TASK: For the given bill, output a JSON object with EXACTLY this structure and nothing else — no markdown, no explanation, just the raw JSON:

{
  "billSummary": "2-3 sentence summary of what the bill does",
  "outcome": "PASSES" or "FAILS" or "TOO CLOSE TO CALL",
  "passageProbability": 67,
  "yesTotal": 20,
  "noTotal": 15,
  "undecidedTotal": 3,
  "votes": [
    {
      "id": "s1",
      "yesPct": 92,
      "noPct": 5,
      "noVotePct": 3,
      "reason": "Brief reason for this prediction"
    }
  ],
  "swingVotes": ["s8", "s30", "s11"],
  "swingAnalysis": "2-3 sentences on the most persuadable members and why",
  "strategicRecs": ["Recommendation 1", "Recommendation 2", "Recommendation 3"],
  "confidenceNote": "Brief confidence assessment"
}

Rules:
- yesPct + noPct + noVotePct must equal 100 for every member
- yesPct = probability they vote YES (0-100)
- noPct = probability they vote NO (0-100)  
- noVotePct = probability they abstain/not vote (0-100)
- Include ALL ${(chamber === "Senate" ? SENATE_MEMBERS : HOUSE_MEMBERS).length} members
- Base predictions on party, ideology score, district, key issues
- Swing votes: members with yesPct between 35-65
- Output ONLY valid JSON, nothing else${votingStats ? '\n\nREAL VOTING DATA (use yea_rate to calibrate per-member predictions):\n' + votingStats : ''}` + '';
};

// ─── COLOR HELPERS ────────────────────────────────────────────────────────────

// Returns CSS color based on yes probability
function seatColor(yesPct, noPct, noVotePct) {
  if (yesPct >= 85) return { bg: "#166534", border: "#4ade80", label: "#4ade80" };
  if (yesPct >= 65) return { bg: "#14532d", border: "#86efac", label: "#86efac" };
  if (yesPct >= 50) return { bg: "#1a3a1a", border: "#6ee7b7", label: "#6ee7b7" };
  if (noPct >= 85) return { bg: "#7f1d1d", border: "#f87171", label: "#f87171" };
  if (noPct >= 65) return { bg: "#6b1a1a", border: "#fca5a5", label: "#fca5a5" };
  if (noPct >= 50) return { bg: "#4a1515", border: "#fecaca", label: "#fecaca" };
  if (noVotePct >= 50) return { bg: "#292524", border: "#78716c", label: "#a8a29e" };
  return { bg: "#3f3c28", border: "#c9a84c", label: "#c9a84c" }; // toss-up
}

function outcomeColor(outcome) {
  if (outcome === "PASSES") return { bg: "rgba(22,101,52,0.3)", border: "#4ade80", color: "#4ade80" };
  if (outcome === "FAILS") return { bg: "rgba(127,29,29,0.3)", border: "#f87171", color: "#f87171" };
  return { bg: "rgba(201,168,76,0.15)", border: "#c9a84c", color: "#c9a84c" };
}

// ─── STYLES ──────────────────────────────────────────────────────────────────

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;800&family=IBM+Plex+Sans:wght@300;400;500&family=IBM+Plex+Mono:wght@400;500&display=swap');
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}
html,body{height:100%;}
/* Theme variables defined globally in public/theme.css */
body{background:var(--bg);color:var(--text);font-family:var(--font-body);-webkit-font-smoothing:antialiased;}
.fv-page{display:flex;flex-direction:column;height:100vh;overflow:hidden;}
.header{padding:0.85rem 2rem;background:var(--surface);border-bottom:1px solid var(--border);display:flex;align-items:center;justify-content:space-between;flex-shrink:0;}
.header-left{display:flex;align-items:center;gap:1rem;}
.logo{font-family:var(--font-display);font-size:1.1rem;font-weight:800;color:var(--text);}
.logo em{font-style:normal;color:var(--gold);}
.logo sup{font-family:var(--font-body);font-size:0.5rem;color:var(--muted);vertical-align:super;}
.page-title{font-family:var(--font-mono);font-size:0.7rem;color:var(--muted);letter-spacing:0.1em;text-transform:uppercase;padding-left:1rem;border-left:1px solid var(--border);}

/* LEGISIM MASTHEAD */
.legisim-masthead{flex-shrink:0;background:var(--surface);border-bottom:2px solid rgba(201,168,76,0.22);padding:0 1.25rem;display:flex;align-items:center;justify-content:space-between;height:58px;position:relative;z-index:20;}
.fv-page .legisim-masthead:.fv-embedded .legisim-masthead::before{content:'';position:absolute;top:0;left:0;right:0;height:2px;background:linear-gradient(90deg,transparent 0%,var(--gold) 30%,#e8c96a 50%,var(--gold) 70%,transparent 100%);}
.fv-page .legisim-masthead:.fv-embedded .legisim-masthead::after{content:'';position:absolute;inset:0;background-image:linear-gradient(rgba(201,168,76,0.025) 1px,transparent 1px),linear-gradient(90deg,rgba(201,168,76,0.025) 1px,transparent 1px);background-size:44px 44px;pointer-events:none;}
.masthead-left{display:flex;align-items:center;gap:1rem;z-index:1;}
.masthead-right{display:flex;align-items:center;gap:0.6rem;z-index:1;}
.mast-back{background:transparent;border:2px solid var(--gold-dim);border-radius:8px;padding:0.45rem 1.1rem;color:var(--gold);font-family:var(--font-mono);font-size:0.72rem;font-weight:600;cursor:pointer;letter-spacing:0.07em;transition:all 0.18s;white-space:nowrap;}
.fv-page .mast-back:.fv-embedded .mast-back:hover{border-color:var(--gold);background:var(--gold-glow);}
.mast-btn-sm{background:transparent;border:1px solid var(--border);border-radius:8px;padding:0.4rem 1rem;color:var(--muted);font-family:var(--font-mono);font-size:0.7rem;cursor:pointer;letter-spacing:0.06em;transition:all 0.18s;white-space:nowrap;}
.fv-page .mast-btn-sm:.fv-embedded .mast-btn-sm:hover{border-color:var(--gold-dim);color:var(--gold);}
.mast-btn-sm.signout:hover{border-color:rgba(192,57,43,0.5);color:var(--red);}
.masthead-wordmark{display:flex;align-items:baseline;font-family:var(--font-display);font-size:1.35rem;font-weight:800;letter-spacing:-0.02em;color:var(--text);line-height:1;white-space:nowrap;}
.masthead-wordmark em{font-style:italic;color:var(--gold);}
.masthead-wordmark sup{font-family:var(--font-mono);font-size:0.42rem;font-weight:500;color:var(--muted);vertical-align:super;letter-spacing:0.08em;margin-left:1px;}
.masthead-divider{width:1px;height:20px;background:var(--border);flex-shrink:0;}
.masthead-tagline{display:none;}
.masthead-badge{display:inline-flex;align-items:center;gap:0.3rem;background:rgba(201,168,76,0.08);border:1px solid rgba(201,168,76,0.2);border-radius:100px;padding:0.18rem 0.6rem;font-family:var(--font-mono);font-size:0.54rem;color:var(--gold);letter-spacing:0.1em;text-transform:uppercase;white-space:nowrap;}
.masthead-badge-dot{width:5px;height:5px;border-radius:50%;background:var(--gold);animation:mbpulse 2.5s infinite;}
@keyframes mbpulse{0%,100%{opacity:0.4;transform:scale(0.85)}50%{opacity:1;transform:scale(1.1)}}
.masthead-nav{display:flex;align-items:center;gap:0.3rem;z-index:1;flex-shrink:1;overflow:hidden;}
.mast-btn{background:transparent;border:1px solid var(--border);border-radius:6px;padding:0.36rem 0.7rem;color:var(--muted);font-family:var(--font-mono);font-size:0.64rem;font-weight:500;cursor:pointer;letter-spacing:0.07em;transition:all 0.18s;white-space:nowrap;display:flex;align-items:center;gap:0.3rem;}
.fv-page .mast-btn:.fv-embedded .mast-btn:hover{border-color:var(--gold-dim);color:var(--gold);background:rgba(201,168,76,0.05);}
.mast-btn.gold{border-color:var(--gold-dim);color:var(--gold);}
.mast-btn.gold:hover{background:rgba(201,168,76,0.1);}
.mast-btn.active{border-color:var(--gold);color:var(--gold);background:rgba(201,168,76,0.1);}
.mast-sep{width:1px;height:16px;background:var(--border);margin:0 0.1rem;}

.home-btn{background:transparent;border:1px solid var(--border);border-radius:6px;padding:0.4rem 0.9rem;color:var(--muted);font-family:var(--font-mono);font-size:0.68rem;cursor:pointer;letter-spacing:0.06em;transition:all 0.2s;}
.fv-page .home-btn:.fv-embedded .home-btn:hover{border-color:var(--gold-dim);color:var(--gold);}
.fv-embedded{flex:1;display:flex;flex-direction:column;overflow:hidden;min-height:0;}
.fv-embedded .fv-body{flex:1;min-height:0;}
.chamber-bar{padding:0.65rem 2rem;background:var(--surface);border-bottom:1px solid var(--border);display:flex;align-items:center;gap:1.5rem;flex-shrink:0;}
.chamber-label{font-family:var(--font-mono);font-size:0.65rem;color:var(--muted);letter-spacing:0.1em;text-transform:uppercase;}
.chamber-toggle{display:flex;}
.chamber-btn{background:var(--surface2);color:var(--muted);border:1px solid var(--border);padding:0.45rem 1.25rem;font-family:var(--font-mono);font-size:0.72rem;font-weight:500;cursor:pointer;letter-spacing:0.08em;text-transform:uppercase;transition:all 0.2s;}
.chamber-btn:first-child{border-radius:6px 0 0 6px;border-right:none;}
.chamber-btn:last-child{border-radius:0 6px 6px 0;}
.chamber-btn.active.senate{background:var(--dem-bg);color:var(--dem);border-color:var(--dem);}
.chamber-btn.active.house{background:var(--rep-bg);color:var(--rep);border-color:var(--rep);}
.chamber-stat{font-family:var(--font-mono);font-size:0.78rem;color:var(--text);padding:0.35rem 0.9rem;background:var(--surface2);border:1px solid var(--border);border-radius:6px;letter-spacing:0.03em;}
.d-c{color:#5b8fee;font-weight:600;}.r-c{color:#e85555;font-weight:600;}
.fv-page .fv-body,.fv-embedded .fv-body{flex:1;display:flex;overflow:hidden;min-height:0;}
.fv-embedded .fv-body{flex:1;display:flex;overflow:hidden;min-height:0;}

/* INPUT PANEL — scoped to FloorVote standalone page only */
.fv-page .fv-input-panel{width:340px;flex-shrink:0;border-right:1px solid var(--border);display:flex;flex-direction:column;overflow:hidden;background:var(--surface);}
.fv-panel-header{padding:0.9rem 1.25rem;border-bottom:1px solid var(--border);flex-shrink:0;}
.fv-panel-title{font-family:var(--font-mono);font-size:0.68rem;color:var(--gold);letter-spacing:0.12em;text-transform:uppercase;margin-bottom:0.2rem;}
.fv-panel-sub{font-size:0.75rem;color:var(--muted);font-weight:300;line-height:1.5;}
.fv-upload-zone{margin:0.75rem 1.25rem 0;border:1.5px dashed var(--border);border-radius:8px;padding:0.7rem;text-align:center;cursor:pointer;transition:all 0.2s;flex-shrink:0;}
.fv-page .fv-upload-zone:.fv-embedded .fv-upload-zone:hover,.upload-zone.drag{border-color:var(--gold-dim);background:var(--gold-glow);}
.fv-upload-zone input{display:none;}
.fv-upload-text{font-size:0.7rem;color:var(--muted);font-family:var(--font-mono);}
.fv-upload-text strong{color:var(--gold);}
.fv-uploaded-file{margin:0.4rem 1.25rem 0;background:var(--charcoal);border:1px solid var(--border);border-radius:5px;padding:0.4rem 0.65rem;display:flex;align-items:center;justify-content:space-between;font-size:0.7rem;color:var(--text);font-family:var(--font-mono);flex-shrink:0;}
.fv-uploaded-file button{background:none;border:none;color:var(--muted);cursor:pointer;font-size:0.9rem;}
.fv-bill-textarea{flex:1;margin:0.65rem 1.25rem 0;background:var(--surface2);border:1px solid var(--border);border-radius:8px;padding:0.85rem;color:var(--text);font-family:var(--font-mono);font-size:0.78rem;line-height:1.6;outline:none;resize:none;transition:border-color 0.2s;min-height:120px;}
.fv-page .fv-bill-textarea:.fv-embedded .fv-bill-textarea:focus{border-color:var(--gold-dim);}
.fv-page .fv-bill-textarea:.fv-embedded .fv-bill-textarea::placeholder{color:var(--muted);}
.fv-submit-row{padding:0.65rem 1.25rem 0.9rem;flex-shrink:0;display:flex;gap:0.6rem;}
.simulate-btn{flex:1;padding:0.8rem;border:none;border-radius:8px;font-family:var(--font-body);font-size:0.88rem;font-weight:500;cursor:pointer;transition:background 0.2s;}
.simulate-btn.senate,.simulate-btn.house{background:#c9a84c;color:#09090e;}
.simulate-btn.senate:hover,.simulate-btn.house:hover{background:#c9a84c;color:#09090e;transform:none;}
.simulate-btn:disabled{background:var(--surface2);color:var(--muted);cursor:not-allowed;}
[data-theme="light"] .simulate-btn.senate,[data-theme="light"] .simulate-btn.house{background:#a07830;color:#fff;}
[data-theme="light"] .simulate-btn.senate:hover,[data-theme="light"] .simulate-btn.house:hover{background:#a07830;color:#fff;}
.fv-clear-btn{background:transparent;border:1px solid var(--border);border-radius:8px;padding:0.8rem 0.9rem;color:var(--muted);font-family:var(--font-body);font-size:0.8rem;cursor:pointer;transition:all 0.2s;}
.fv-page .fv-clear-btn:.fv-embedded .fv-clear-btn:hover{color:var(--text);}

/* RIGHT PANEL */
.fv-right-panel{flex:1;display:flex;flex-direction:column;overflow:hidden;min-width:0;}
.fv-right-scroll{flex:1;overflow-y:auto;scrollbar-width:thin;scrollbar-color:var(--border) transparent;}
::-webkit-scrollbar{width:4px;}
::-webkit-scrollbar-thumb{background:var(--border);border-radius:4px;}

/* SCOREBOARD */
.scoreboard{display:flex;gap:1px;background:var(--border);border-bottom:1px solid var(--border);}
.score-cell{flex:1;background:var(--surface);padding:0.85rem 1rem;text-align:center;}
.score-num{font-family:var(--font-display);font-size:2rem;font-weight:800;line-height:1;}
.score-num.yes{color:#4ade80;}.score-num.no{color:#f87171;}.score-num.und{color:var(--gold);}
.score-label{font-family:var(--font-mono);font-size:0.58rem;color:var(--muted);letter-spacing:0.08em;text-transform:uppercase;margin-top:0.2rem;}
.outcome-row{padding:0.75rem 1.5rem;background:var(--surface);border-bottom:1px solid var(--border);display:flex;align-items:center;gap:1rem;flex-wrap:wrap;}
.outcome-badge{display:inline-flex;align-items:center;gap:0.4rem;padding:0.4rem 1rem;border-radius:100px;font-family:var(--font-mono);font-size:0.72rem;font-weight:600;letter-spacing:0.08em;}
.outcome-badge.pass{background:rgba(22,101,52,0.3);border:1px solid #4ade80;color:#4ade80;}
.outcome-badge.fail{background:rgba(127,29,29,0.3);border:1px solid #f87171;color:#f87171;}
.outcome-badge.close{background:rgba(201,168,76,0.15);border:1px solid #c9a84c;color:#c9a84c;}
.bill-summary-text{font-size:0.8rem;color:var(--muted);flex:1;line-height:1.55;}

/* FLOOR MAP */
.floor-section{padding:1.25rem 1.5rem;border-bottom:1px solid var(--border);}
.floor-title{font-family:var(--font-mono);font-size:0.65rem;color:var(--gold);letter-spacing:0.12em;text-transform:uppercase;margin-bottom:0.85rem;}
.floor-legend{display:flex;gap:0.6rem;flex-wrap:wrap;margin-bottom:1rem;}
.legend-item{display:flex;align-items:center;gap:0.35rem;font-family:var(--font-mono);font-size:0.6rem;color:var(--muted);}
.legend-dot{width:10px;height:10px;border-radius:2px;flex-shrink:0;}
/* SVG chamber styles handled inline */

/* TOOLTIP */
.tooltip-overlay{position:fixed;z-index:1000;pointer-events:none;}
.tooltip{background:var(--charcoal);border:1px solid var(--border);border-radius:10px;padding:0.85rem 1rem;min-width:220px;max-width:280px;box-shadow:0 8px 32px rgba(0,0,0,0.5);}
.tip-name{font-family:var(--font-display);font-size:0.9rem;font-weight:700;color:var(--text);margin-bottom:0.15rem;}
.tip-sub{font-family:var(--font-mono);font-size:0.62rem;color:var(--muted);margin-bottom:0.6rem;}
.tip-bars{display:flex;flex-direction:column;gap:0.35rem;margin-bottom:0.6rem;}
.tip-bar-row{display:flex;align-items:center;gap:0.5rem;}
.tip-bar-label{font-family:var(--font-mono);font-size:0.6rem;width:52px;flex-shrink:0;}
.tip-bar-label.yes{color:#4ade80;}.tip-bar-label.no{color:#f87171;}.tip-bar-label.nov{color:var(--muted);}
.tip-bar-track{flex:1;height:6px;background:var(--surface);border-radius:100px;overflow:hidden;}
.tip-bar-fill{height:100%;border-radius:100px;transition:width 0.3s;}
.tip-bar-fill.yes{background:#4ade80;}.tip-bar-fill.no{background:#f87171;}.tip-bar-fill.nov{background:var(--muted);}
.tip-bar-pct{font-family:var(--font-mono);font-size:0.62rem;width:30px;text-align:right;flex-shrink:0;}
.tip-bar-pct.yes{color:#4ade80;}.tip-bar-pct.no{color:#f87171;}.tip-bar-pct.nov{color:var(--muted);}
.tip-reason{font-size:0.75rem;color:var(--muted);line-height:1.5;border-top:1px solid var(--border);padding-top:0.5rem;margin-top:0.1rem;}

/* DETAIL SECTION */
.detail-section{padding:1rem 1.5rem;border-bottom:1px solid var(--border);}
.detail-title{font-family:var(--font-mono);font-size:0.65rem;color:var(--gold);letter-spacing:0.12em;text-transform:uppercase;margin-bottom:0.65rem;padding-bottom:0.3rem;border-bottom:1px solid var(--border);}
.detail-body{font-size:0.85rem;color:var(--text);line-height:1.7;}
.detail-body p{margin-bottom:0.4rem;}
.detail-body strong{color:var(--gold);}
.detail-body li{margin-left:1rem;margin-bottom:0.25rem;color:var(--muted);font-size:0.82rem;}
.vote-table{width:100%;border-collapse:collapse;font-size:0.78rem;}
.vote-table th{font-family:var(--font-mono);font-size:0.6rem;color:var(--muted);text-transform:uppercase;letter-spacing:0.08em;padding:0.4rem 0.6rem;text-align:left;border-bottom:1px solid var(--border);}
.vote-table td{padding:0.35rem 0.6rem;border-bottom:1px solid rgba(255,255,255,0.03);}
.vote-table tr:hover td{background:var(--surface2);}
.pct-yes{color:#4ade80;font-family:var(--font-mono);}
.pct-no{color:#f87171;font-family:var(--font-mono);}
.pct-nov{color:var(--muted);font-family:var(--font-mono);}
.party-chip{font-family:var(--font-mono);font-size:0.6rem;padding:0.1rem 0.35rem;border-radius:4px;}
.party-chip.D{background:var(--dem-bg);color:var(--dem);}
.party-chip.R{background:var(--rep-bg);color:var(--rep);}
.swing-chip{background:rgba(201,168,76,0.15);border:1px solid var(--gold-dim);color:var(--gold);font-family:var(--font-mono);font-size:0.6rem;padding:0.1rem 0.4rem;border-radius:4px;}

/* EMPTY / LOADING */
.fv-empty-state{height:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:0.75rem;color:var(--muted);text-align:center;padding:2rem;}
.fv-empty-glyph{font-size:3.5rem;opacity:0.12;font-family:var(--font-display);font-weight:800;color:var(--gold);}
.fv-empty-title{font-family:var(--font-display);font-size:1.15rem;color:var(--text);opacity:0.4;font-weight:700;}
.fv-empty-sub{font-size:0.82rem;max-width:300px;line-height:1.65;font-weight:300;}
.loading-state{height:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:1.25rem;}
.loading-title{font-family:var(--font-mono);font-size:0.75rem;color:var(--gold);letter-spacing:0.1em;text-transform:uppercase;}
.loading-dots{display:flex;gap:8px;}
.loading-dot{width:8px;height:8px;border-radius:50%;background:var(--gold);animation:ldot 1.2s infinite;}
.loading-dot:nth-child(2){animation-delay:0.2s;}
.loading-dot:nth-child(3){animation-delay:0.4s;}
@keyframes ldot{0%,100%{opacity:0.2;transform:scale(0.8)}50%{opacity:1;transform:scale(1)}}
@media(max-width:1200px){
  .mast-btn{padding:0.3rem 0.45rem;font-size:0.58rem;letter-spacing:0.03em;}
  .masthead-nav{gap:0.2rem;}
}
@media(max-width:900px){
  .mast-btn{padding:0.28rem 0.38rem;font-size:0.55rem;}
  .masthead-nav{gap:0.15rem;}
}
@media(max-width:768px){
  .masthead-nav{display:none !important;}
  .legisim-masthead{flex-shrink:0;background:var(--surface);border-bottom:2px solid rgba(201,168,76,0.22);padding:0 1.25rem;display:flex;align-items:center;justify-content:space-between;height:58px;position:relative;z-index:20;}
}


/* ── LIGHT MODE OVERRIDES ── */
[data-theme="light"] body{background:#eef1f7;color:#1a1e2e;}
[data-theme="light"] .fv-page .page,.fv-embedded .page,[data-theme="light"] .app,[data-theme="light"] .bt-app,[data-theme="light"] .tl-app,[data-theme="light"] .map-app,[data-theme="light"] .cf-app{background:#eef1f7;}
[data-theme="light"] .legisim-masthead{background:#1a2744;border-bottom-color:rgba(255,255,255,0.1);}
[data-theme="light"] .fv-page .legisim-masthead:.fv-embedded .legisim-masthead::before{background:linear-gradient(90deg,transparent,var(--gold),transparent);}
[data-theme="light"] .masthead-wordmark{color:#e6e4dc;}
[data-theme="light"] .masthead-wordmark em{color:#c9a84c;}
[data-theme="light"] .masthead-wordmark sup{color:rgba(230,228,220,0.5);}
[data-theme="light"] .mast-back{border-color:rgba(201,168,76,0.6);color:#c9a84c;background:transparent;}
[data-theme="light"] .fv-page .mast-back:.fv-embedded .mast-back:hover{background:rgba(201,168,76,0.12);border-color:#c9a84c;color:#c9a84c;}
[data-theme="light"] .mast-btn-sm{color:#e6e4dc;border-color:rgba(201,168,76,0.4);}
[data-theme="light"] .fv-page .mast-btn-sm:.fv-embedded .mast-btn-sm:hover{color:#ffffff;border-color:#c9a84c;background:rgba(201,168,76,0.1);}
[data-theme="light"] .mast-btn-sm.signout:hover{border-color:rgba(192,57,43,0.7);color:#ff6b6b;background:rgba(192,57,43,0.1);}
[data-theme="light"] .sidebar,[data-theme="light"] .bt-left,[data-theme="light"] .cal-sidebar,[data-theme="light"] .cf-sidebar,[data-theme="light"] .map-left{background:#f8f9fc;border-color:rgba(26,39,68,0.12);}
[data-theme="light"] .main,[data-theme="light"] .bt-detail,[data-theme="light"] .cf-main{background:#eef1f7;}
[data-theme="light"] .filter-btn,[data-theme="light"] .vh-filter-btn{background:#f8f9fc;border-color:rgba(26,39,68,0.12);color:#6b7280;}
[data-theme="light"] .filter-btn.active,[data-theme="light"] .vh-filter-btn.active{background:rgba(26,39,68,0.1);border-color:rgba(26,39,68,0.3);color:#1a2744;}
[data-theme="light"] .filter-btn.dem-active{background:var(--dem-bg);border-color:var(--dem);color:var(--dem);}
[data-theme="light"] .filter-btn.rep-active{background:var(--rep-bg);border-color:var(--rep);color:var(--rep);}
[data-theme="light"] .search-input,[data-theme="light"] .chat-input,[data-theme="light"] .bt-search-input,[data-theme="light"] .tl-search-input{background:#f8f9fc;border-color:rgba(26,39,68,0.12);color:#1a1e2e;}
[data-theme="light"] .leg-item.selected{background:#e8ecf4;}
[data-theme="light"] .leg-item.selected::before{background:#1a2744;}
[data-theme="light"] .leg-item:hover{background:#e8ecf4;}
[data-theme="light"] .chat-input-area{background:#f8f9fc;border-color:rgba(26,39,68,0.12);}
[data-theme="light"] .msg-bubble{background:#f0f2f8;border-color:rgba(26,39,68,0.1);}
[data-theme="light"] .msg.user .msg-bubble{background:#e8ecf4;border-color:rgba(26,39,68,0.2);}
[data-theme="light"] .send-btn{background:#1a2744;color:#f8f9fc;}
[data-theme="light"] .main-topbar,[data-theme="light"] .news-topbar,[data-theme="light"] .chamber-bar,[data-theme="light"] .toggle-bar{background:#f8f9fc;border-color:rgba(26,39,68,0.12);}
[data-theme="light"] .vh-header,[data-theme="light"] .vh-filters,[data-theme="light"] .vh-stats{background:#f8f9fc;border-color:rgba(26,39,68,0.12);}
[data-theme="light"] .vh-bill-number,[data-theme="light"] .bt-bill-number,[data-theme="light"] .bt-detail-number,[data-theme="light"] .tl-bill-number,[data-theme="light"] .district-num{color:#1a2744;}
[data-theme="light"] .profile-section-label,[data-theme="light"] .section-label,[data-theme="light"] .form-label,[data-theme="light"] .fv-page .fv-panel-title,.fv-embedded .fv-panel-title,[data-theme="light"] .output-label,[data-theme="light"] .floor-title,[data-theme="light"] .detail-title,[data-theme="light"] .search-section-label{color:#1a2744;}
[data-theme="light"] .fv-page .fv-input-panel,[data-theme="light"] .fv-embedded .fv-input-panel{background:#f8f9fc;border-color:rgba(26,39,68,0.12);}
[data-theme="light"] .output-panel,[data-theme="light"] .output-body{background:#eef1f7;}
[data-theme="light"] .tl-add-btn,[data-theme="light"] .tl-refresh-btn,[data-theme="light"] .tl-view-btn{color:#1a2744;border-color:rgba(26,39,68,0.2);}
[data-theme="light"] .tl-table-head{background:#e8ecf4;}
[data-theme="light"] .tl-tr:hover{background:#e8ecf4;}
[data-theme="light"] .date-group-header{color:#1a2744;border-color:rgba(26,39,68,0.12);}
[data-theme="light"] .detail-header,[data-theme="light"] .profile-header,[data-theme="light"] .donors-section,[data-theme="light"] .bt-detail-header{background:#f8f9fc;border-color:rgba(26,39,68,0.12);}
[data-theme="light"] .acct-card{background:#f8f9fc;border-color:rgba(26,39,68,0.12);}
[data-theme="light"] .news-tab.active{color:#1a2744;border-color:#1a2744;}
[data-theme="light"] .story-source{color:#6b7280;}
[data-theme="light"] .profile-sidebar{background:#f8f9fc;border-color:rgba(26,39,68,0.12);}
[data-theme="light"] .home-title{color:#1a2744;}
[data-theme="light"] .cf-amount,[data-theme="light"] .cf-total{color:#1a2744;}
[data-theme="light"] .chamber-btn.active{background:rgba(26,39,68,0.1);color:#1a2744;border-color:rgba(26,39,68,0.3);}
[data-theme="light"] .swing-chip{background:rgba(26,39,68,0.1);color:#1a2744;}
[data-theme="light"] .score-cell.pass{background:rgba(37,107,66,0.12);}
[data-theme="light"] .score-cell.fail{background:rgba(176,48,32,0.08);}
[data-theme="light"] .map-tooltip-district{color:#1a2744;}
[data-theme="light"] .watchlist-btn-small,[data-theme="light"] .watch-btn{border-color:rgba(160,120,48,0.4);color:#a07830;}
[data-theme="light"] .vote-history-btn{background:rgba(160,120,48,0.08);border-color:rgba(160,120,48,0.35);color:#a07830;}
[data-theme="light"] .masthead-badge{background:rgba(26,39,68,0.08);border-color:rgba(26,39,68,0.2);}
[data-theme="light"] .masthead-badge-dot{background:#1a2744;}
[data-theme="light"] .mast-btn.gold{border-color:rgba(160,120,48,0.4);color:#a07830;}
[data-theme="light"] .mast-btn.active{background:rgba(26,39,68,0.1);border-color:rgba(26,39,68,0.3);color:#1a2744;}
[data-theme="light"] .issue-tag{background:#e8ecf4;border-color:rgba(26,39,68,0.12);color:#1a1e2e;}
[data-theme="light"] .qp-btn{background:#f0f2f8;border-color:rgba(26,39,68,0.12);color:#6b7280;}
[data-theme="light"] .empty-card{background:#f0f2f8;border-color:rgba(26,39,68,0.12);}
[data-theme="light"] .donor-bar-fill{background:linear-gradient(90deg,#1a2744,#2d4a80);}
[data-theme="light"] .cf-leg-item.active,[data-theme="light"] .bt-bill-item.selected{border-left-color:#1a2744;}
[data-theme="light"] .subject-tag{background:#e8ecf4;border-color:rgba(26,39,68,0.12);color:#1a1e2e;}
[data-theme="light"] .plan-badge,[data-theme="light"] .admin{color:#1a2744;}
[data-theme="light"] .login-card{background:#f8f9fc;border-color:rgba(26,39,68,0.12);box-shadow:0 4px 24px rgba(26,39,68,0.1);}
`;

// ─── CURVED CHAMBER LAYOUT ENGINE ────────────────────────────────────────────

// Generates (x,y) positions for seats arranged in concentric semicircular arcs.
// origin = bottom-center of SVG. Each arc is a row of seats.
// Democrats sit on presiding officer's RIGHT (negative angle = left side of screen from viewer = right from podium)
// Republicans sit on presiding officer's LEFT

function buildChamberSeats(arcs, svgW, svgH, cx, cy, rStart, rStep, spanDeg) {
  const seats = [];
  arcs.forEach((arc, ai) => {
    const r = rStart + ai * rStep;
    const n = arc.length;
    arc.forEach((district, si) => {
      const frac = n > 1 ? si / (n - 1) : 0.5;
      const angleDeg = -spanDeg / 2 + frac * spanDeg;
      const angleRad = (angleDeg - 90) * Math.PI / 180;
      seats.push({
        district,
        x: cx + r * Math.cos(angleRad),
        y: cy + r * Math.sin(angleRad),
        arc: ai,
      });
    });
  });
  return seats;
}

// Senate: 4 arcs of 9,10,10,8 seats (37 members, no district 35)
const SENATE_ARCS = [
  [1,2,3,4,5,6,7,8,9],
  [10,11,12,13,14,15,16,17,18,19],
  [20,21,22,23,24,25,26,27,28,29],
  [30,31,32,33,34,36,37,38],
];
const SENATE_SVG = { w:700, h:330, cx:350, cy:330, rStart:110, rStep:62, span:168 };
const SENATE_SEATS = buildChamberSeats(SENATE_ARCS, ...Object.values(SENATE_SVG));

// House: 7 arcs of 16,16,16,16,16,16,14 seats (110 members)
const HOUSE_ARCS = [
  [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16],
  [17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32],
  [33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48],
  [49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64],
  [65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80],
  [81,82,83,84,85,86,87,88,89,90,91,92,93,94,95,96],
  [97,98,99,100,101,102,103,104,105,106,107,108,109,110],
];
const HOUSE_SVG  = { w:700, h:390, cx:350, cy:395, rStart:90, rStep:46, span:172 };
const HOUSE_SEATS  = buildChamberSeats(HOUSE_ARCS, ...Object.values(HOUSE_SVG));

// ─── MAIN COMPONENT ───────────────────────────────────────────────────────────

async function handleSignOut(supabaseClient, onNavigate) {
  await supabaseClient.auth.signOut();
  onNavigate('home');
}

// ─── FLOOR VOTE RATE LIMITING ─────────────────────────────────────────────────
const FV_MONTHLY_LIMIT = 25;

async function getFVUsage(userId) {
  const month = new Date().toISOString().slice(0, 7); // "2026-04"
  const { data } = await supabase
    .from("query_usage")
    .select("count")
    .eq("user_id", userId)
    .eq("query_date", month + "-fv")
    .single();
  return data?.count || 0;
}

async function incrementFVUsage(userId) {
  const month = new Date().toISOString().slice(0, 7);
  const dateKey = month + "-fv";
  const { data } = await supabase
    .from("query_usage")
    .select("id, count")
    .eq("user_id", userId)
    .eq("query_date", dateKey)
    .single();
  if (data) {
    await supabase.from("query_usage").update({ count: data.count + 1, updated_at: new Date().toISOString() }).eq("id", data.id);
    return data.count + 1;
  } else {
    await supabase.from("query_usage").insert({ user_id: userId, query_date: dateKey, count: 1 });
    return 1;
  }
}

export default function FloorVoteSimulator({ onNavigate, session, profile, embedded = false, externalResult, externalLoading, externalChamber }) {
  const [chamber, setChamber] = useState("Senate");
  const [fvUsed, setFvUsed] = useState(0);

  useEffect(() => {
    if (session?.user?.id && profile?.role !== "admin") {
      getFVUsage(session.user.id).then(count => setFvUsed(count));
    }
  }, [session]);
  const [billText, setBillText] = useState("");
  const [fileName, setFileName] = useState(null);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  // When embedded with external state (from BillStudio), use those instead
  const activeResult = externalResult !== undefined ? externalResult : result;
  const activeLoading = externalLoading !== undefined ? externalLoading : loading;
  const activeChamber = externalChamber !== undefined ? externalChamber : chamber;
  const [tooltip, setTooltip] = useState(null); // { member, vote, x, y }
  const [selectedSeat, setSelectedSeat] = useState(null);
  const [drag, setDrag] = useState(false);
  const fileRef = useRef(null);

  const members = activeChamber === "Senate" ? SENATE_MEMBERS : HOUSE_MEMBERS;
  const seatPositions = activeChamber === "Senate" ? SENATE_SEATS : HOUSE_SEATS;
  const svgDims = activeChamber === "Senate" ? SENATE_SVG : HOUSE_SVG;

  // Build vote map from result
  const voteMap = {};
  if (activeResult?.votes) {
    activeResult.votes.forEach(v => { voteMap[v.id] = v; });
  }

  const handleFile = async (file) => {
    if (!file) return;
    setFileName(file.name);
    setBillText(await file.text());
  };

  const simulate = async () => {
    if (!billText.trim() || loading) return;
    setLoading(true);
    setResult(null);
    setSelectedSeat(null);
    // Check monthly limit
    if (profile?.role !== "admin" && fvUsed >= FV_MONTHLY_LIMIT) {
      setResult({ error: `You've reached your ${FV_MONTHLY_LIMIT} monthly simulation limit. Resets on the 1st of next month.` });
      setLoading(false);
      return;
    }
    try {
      const members = activeChamber === "Senate" ? SENATE_MEMBERS : HOUSE_MEMBERS;
      let votingStats = "";
      try {
        const memberVotes = await fetchAllFVMemberVotes(members);
        votingStats = formatFVVotingStats(memberVotes, members);
      } catch(e) {}

      const maxTok = activeChamber === "House" ? 8000 : 5000;
      const response = await fetch("https://legisim-server.onrender.com/api/chat", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          model: "claude-sonnet-4-20250514",
          max_tokens: maxTok,
          system: buildPrompt(activeChamber, votingStats),
          messages: [{ role: "user", content: `Simulate a floor vote in the Michigan ${activeChamber} for:\n\n${billText.trim()}` }],
        }),
      });
      if (!response.ok) {
        const errData = await response.json().catch(() => ({}));
        throw new Error(errData.detail || errData.error || `HTTP ${response.status}`);
      }
      const data = await response.json();
      if (data.error) throw new Error(data.detail || data.error);
      const text = data.content?.map(c => c.text || "").join("") || "";
      // Extract JSON — handle truncated responses by finding largest valid JSON object
      const jsonMatch = text.match(/\{[\s\S]*\}/);
      if (!jsonMatch) throw new Error("No JSON in response: " + text.slice(0, 200));
      let parsed;
      try {
        parsed = JSON.parse(jsonMatch[0]);
      } catch (parseErr) {
        // Try to repair truncated JSON by finding last complete vote entry
        const truncated = jsonMatch[0];
        const lastComplete = truncated.lastIndexOf('}],');
        if (lastComplete > 0) {
          try {
            parsed = JSON.parse(truncated.slice(0, lastComplete + 2) + ',"swingVotes":[],"swingAnalysis":"","strategicRecs":[],"confidenceNote":"Response was truncated."}');
          } catch { throw new Error("JSON parse failed after repair attempt"); }
        } else {
          throw parseErr;
        }
      }
      setResult(parsed);
      if (session?.user?.id && profile?.role !== "admin") {
        const newCount = await incrementFVUsage(session.user.id);
        setFvUsed(newCount);
      }
    } catch (e) {
      console.error("Simulation error:", e);
      setResult({ error: `Simulation failed: ${e.message}` });
    }
    setLoading(false);
  };

  const handleSeatHover = (e, member) => {
    const vote = voteMap[member.id];
    if (!vote) return;
    const rect = e.currentTarget.getBoundingClientRect();
    setTooltip({ member, vote, x: rect.left, y: rect.top });
  };

  const handleSeatClick = (member) => {
    setSelectedSeat(selectedSeat?.id === member.id ? null : member);
  };

  const senateD = SENATE_MEMBERS.filter(m => m.party === "D").length;
  const senateR = SENATE_MEMBERS.filter(m => m.party === "R").length;
  const houseD = HOUSE_MEMBERS.filter(m => m.party === "D").length;
  const houseR = HOUSE_MEMBERS.filter(m => m.party === "R").length;

  const outcomeClass = activeResult?.outcome === "PASSES" ? "pass" : result?.outcome === "FAILS" ? "fail" : "close";
  const swingIds = new Set(activeResult?.swingVotes || []);

  return (
    <>
      <style>{CSS}</style>
      {!embedded && <MobileMenuCSS />}
      <div className={embedded ? "fv-embedded" : "fv-page"}>

        {/* MASTHEAD — hidden when embedded inside BillStudio */}
        {!embedded && <div className="legisim-masthead">
          <div className="masthead-left">
            <div className="masthead-wordmark">Whip<em>Count</em><sup>TM</sup></div>
            <button className="mast-back" onClick={() => onNavigate && onNavigate("dashboard")}>← Dashboard</button>
          </div>
          <div className="masthead-right">
            <button className="mast-btn-sm" onClick={() => onNavigate && onNavigate("account")}>Account</button>
            <button className="mast-btn-sm signout" onClick={() => handleSignOut(supabase, onNavigate)}>Sign Out</button>
          </div>
        </div>}
        {/* SUBHEADER - page title bar */}
        {!embedded && <div className="header">
          <div className="header-left">
            <div className="page-title">Floor Vote Simulator</div>
          </div>
        </div>}

        {/* CHAMBER BAR — only shown standalone when not embedded */}
        {!embedded && <div className="chamber-bar">
          <span className="chamber-label">Chamber:</span>
          <div className="chamber-toggle">
            <button className={`chamber-btn${chamber === "Senate" ? " active senate" : ""}`} onClick={() => { setChamber("Senate"); setResult(null); }}>Senate</button>
            <button className={`chamber-btn${chamber === "House" ? " active house" : ""}`} onClick={() => { setChamber("House"); setResult(null); }}>House</button>
          </div>
          <div className="chamber-stat">
            {chamber === "Senate"
              ? <><span className="d-c">{senateD}D</span> / <span className="r-c">{senateR}R</span> · D Majority · 19 to pass</>
              : <><span className="d-c">{houseD}D</span> / <span className="r-c">{houseR}R</span> · R Majority · 56 to pass</>
            }
          </div>
        </div>}

        {/* BODY */}
        <div className="fv-body">

          {/* INPUT — hidden when embedded, BillStudio owns the input panel */}
          {!embedded && <div className="fv-input-panel">
            {/* When embedded: chamber toggle lives inside input panel */}
            {embedded && (
              <div style={{padding:"0.65rem 1rem",borderBottom:"1px solid var(--border)",flexShrink:0}}>
                <div style={{fontFamily:"var(--font-mono)",fontSize:"0.6rem",color:"var(--muted)",letterSpacing:"0.1em",textTransform:"uppercase",marginBottom:"0.4rem"}}>Chamber</div>
                <div style={{display:"flex",gap:"0.5rem",alignItems:"center",flexWrap:"wrap"}}>
                  <div className="chamber-toggle">
                    <button className={`chamber-btn${chamber === "Senate" ? " active senate" : ""}`} onClick={() => { setChamber("Senate"); setResult(null); }}>Senate</button>
                    <button className={`chamber-btn${chamber === "House" ? " active house" : ""}`} onClick={() => { setChamber("House"); setResult(null); }}>House</button>
                  </div>
                  <div className="chamber-stat" style={{fontSize:"0.65rem",padding:"0.2rem 0.5rem"}}>
                    {chamber === "Senate"
                      ? <><span className="d-c">{senateD}D</span> / <span className="r-c">{senateR}R</span> · 19 to pass</>
                      : <><span className="d-c">{houseD}D</span> / <span className="r-c">{houseR}R</span> · 56 to pass</>
                    }
                  </div>
                </div>
              </div>
            )}
            <div className="fv-panel-header">
              <div className="fv-panel-title">Bill Input</div>
              <div className="fv-panel-sub">Enter a bill number, paste text, describe a concept, or upload a file.</div>
            </div>
            <div className={`upload-zone${drag ? " drag" : ""}`}
              onClick={() => fileRef.current?.click()}
              onDragOver={e => { e.preventDefault(); setDrag(true); }}
              onDragLeave={() => setDrag(false)}
              onDrop={e => { e.preventDefault(); setDrag(false); handleFile(e.dataTransfer.files[0]); }}>
              <input ref={fileRef} type="file" accept=".txt,.pdf,.doc,.docx" onChange={e => handleFile(e.target.files[0])} />
              <div className="fv-upload-text">📎 <strong>Upload</strong> or drag · .txt .pdf .doc .docx</div>
            </div>
            {fileName && (
              <div className="fv-uploaded-file">
                <span>📄 {fileName}</span>
                <button onClick={() => { setFileName(null); setBillText(""); }}>✕</button>
              </div>
            )}
            <textarea className="fv-bill-textarea"
              placeholder={"Enter bill to simulate...\n\nExamples:\n• HB 4482 — concealed pistol license reciprocity\n• Paste full bill text\n• Describe any policy concept\n\nCtrl+Enter to simulate."}
              value={billText}
              onChange={e => setBillText(e.target.value)}
              onKeyDown={e => { if (e.key === "Enter" && e.ctrlKey) simulate(); }} />
            <div className="fv-submit-row">
              <button className={`simulate-btn ${chamber.toLowerCase()}`} onClick={simulate} disabled={!billText.trim() || loading || (profile?.role !== "admin" && fvUsed >= FV_MONTHLY_LIMIT)}>
                {loading ? "Simulating…" : profile?.role !== "admin" && fvUsed >= FV_MONTHLY_LIMIT ? "Monthly Limit Reached" : `Simulate ${activeChamber} Vote →`}
              </button>
              {result && <button className="fv-clear-btn" onClick={() => { setResult(null); setBillText(""); setFileName(null); }}>Clear</button>}
            </div>
            {profile?.role !== "admin" && (
              <div style={{fontFamily:"var(--font-mono)",fontSize:"0.62rem",color: fvUsed >= FV_MONTHLY_LIMIT ? "#e05252" : fvUsed >= 20 ? "#e09a52" : "var(--muted)",marginTop:"0.5rem",textAlign:"center"}}>
                {FV_MONTHLY_LIMIT - fvUsed}/{FV_MONTHLY_LIMIT} simulations remaining this month
              </div>
            )}
          </div>}

          {/* RIGHT PANEL */}
          <div className="fv-right-panel">
            {activeLoading ? (
              <div className="loading-state">
                <div className="loading-title">Running simulation across {(activeChamber === "Senate" ? SENATE_MEMBERS : HOUSE_MEMBERS).length} members…</div>
                <div className="loading-dots">
                  <div className="loading-dot"/><div className="loading-dot"/><div className="loading-dot"/>
                </div>
              </div>
            ) : !activeResult ? (
              <div className="fv-empty-state">
                <div className="fv-empty-glyph">⚖</div>
                <div className="fv-empty-title">Ready to simulate</div>
                <div className="fv-empty-sub">Enter any bill and see how every seat lights up with color-coded probability predictions on the actual floor map.</div>
              </div>
            ) : activeResult.error ? (
              <div className="fv-empty-state"><div className="fv-empty-sub" style={{color:"#f87171"}}>{activeResult.error}</div></div>
            ) : (
              <div className="fv-right-scroll">

                {/* SCOREBOARD */}
                <div className="scoreboard">
                  <div className="score-cell"><div className="score-num yes">{activeResult.yesTotal}</div><div className="score-label">Projected Yes</div></div>
                  <div className="score-cell"><div className="score-num no">{activeResult.noTotal}</div><div className="score-label">Projected No</div></div>
                  <div className="score-cell"><div className="score-num und">{activeResult.undecidedTotal}</div><div className="score-label">Undecided</div></div>
                </div>

                {/* OUTCOME */}
                <div className="outcome-row">
                  <span className={`outcome-badge ${outcomeClass}`}>
                    {activeResult.outcome === "PASSES" ? "✅" : activeResult.outcome === "FAILS" ? "❌" : "⚠️"} {activeResult.outcome} · {activeResult.passageProbability}% probability
                  </span>
                  <span className="bill-summary-text">{activeResult.billSummary}</span>
                </div>

                {/* FLOOR MAP */}
                <div className="floor-section">
                  <div className="floor-title">🏛 {activeChamber} Floor — Hover a seat for details, click to pin</div>
                  <div className="floor-legend">
                    {[
                      { color: "#166534", border: "#4ade80", label: "85-100% Yes" },
                      { color: "#14532d", border: "#86efac", label: "65-84% Yes" },
                      { color: "#1a3a1a", border: "#6ee7b7", label: "50-64% Yes" },
                      { color: "#3f3c28", border: "#c9a84c", label: "Toss-up" },
                      { color: "#4a1515", border: "#fecaca", label: "50-64% No" },
                      { color: "#6b1a1a", border: "#fca5a5", label: "65-84% No" },
                      { color: "#7f1d1d", border: "#f87171", label: "85-100% No" },
                      { color: "#292524", border: "#78716c", label: "Likely No Vote" },
                    ].map(l => (
                      <div className="legend-item" key={l.label}>
                        <div className="legend-dot" style={{ background: l.color, border: `1.5px solid ${l.border}` }} />
                        {l.label}
                      </div>
                    ))}
                  </div>

                  {/* SVG CURVED CHAMBER */}
                  <div style={{ background:"var(--surface2)", borderRadius:14, border:"1px solid var(--border)", padding:"0.5rem", overflow:"hidden" }}>
                    <svg
                      viewBox={`0 0 ${svgDims.w} ${svgDims.h}`}
                      style={{ width:"100%", display:"block" }}
                    >
                      {/* Subtle arc guide lines */}
                      {(chamber === "Senate" ? SENATE_ARCS : HOUSE_ARCS).map((arc, ai) => {
                        const r = svgDims.rStart + ai * svgDims.rStep;
                        const spanRad = svgDims.span * Math.PI / 180;
                        const startAngle = (-svgDims.span/2 - 90) * Math.PI / 180;
                        const endAngle = (svgDims.span/2 - 90) * Math.PI / 180;
                        const x1 = svgDims.cx + r * Math.cos(startAngle);
                        const y1 = svgDims.cy + r * Math.sin(startAngle);
                        const x2 = svgDims.cx + r * Math.cos(endAngle);
                        const y2 = svgDims.cy + r * Math.sin(endAngle);
                        return (
                          <path
                            key={ai}
                            d={`M ${x1} ${y1} A ${r} ${r} 0 0 1 ${x2} ${y2}`}
                            fill="none"
                            stroke="rgba(255,255,255,0.04)"
                            strokeWidth="1"
                          />
                        );
                      })}

                      {/* Center aisle divider */}
                      <line
                        x1={svgDims.cx} y1={svgDims.cy - svgDims.rStart - svgDims.rStep * ((chamber==="Senate"?SENATE_ARCS:HOUSE_ARCS).length - 0.5)}
                        x2={svgDims.cx} y2={svgDims.cy}
                        stroke="rgba(255,255,255,0.08)"
                        strokeWidth="1.5"
                        strokeDasharray="4,4"
                      />

                      {/* D / R side labels */}
                      <text x={svgDims.cx - 18} y={30} fill="rgba(59,111,212,0.5)" fontSize="9" fontFamily="IBM Plex Mono" textAnchor="middle">D</text>
                      <text x={svgDims.cx + 18} y={30} fill="rgba(212,59,59,0.5)" fontSize="9" fontFamily="IBM Plex Mono" textAnchor="middle">R</text>

                      {/* Podium */}
                      <rect x={svgDims.cx - 34} y={svgDims.cy - 22} width={68} height={22} rx={5} fill="#1e1e28" stroke="rgba(201,168,76,0.4)" strokeWidth="1" />
                      <text x={svgDims.cx} y={svgDims.cy - 7} fill="#c9a84c" fontSize="7" fontFamily="IBM Plex Mono" textAnchor="middle" fontWeight="600">
                        {chamber === "Senate" ? "LT. GOVERNOR" : "SPEAKER"}
                      </text>

                      {/* Seats */}
                      {seatPositions.map(({ district, x, y, arc: arcIdx }) => {
                        const member = members.find(m => m.district === district);
                        if (!member) return null;
                        const vote = voteMap[member.id];
                        const isSwing = swingIds.has(member.id);
                        const isSelected = selectedSeat?.id === member.id;
                        const R = chamber === "Senate" ? 12 : 10;

                        let fill, stroke, textColor;
                        if (!vote) {
                          fill = "#1e1e28"; stroke = "rgba(255,255,255,0.12)"; textColor = "rgba(255,255,255,0.3)";
                        } else {
                          const c = seatColor(vote.yesPct, vote.noPct, vote.noVotePct);
                          fill = c.bg; stroke = c.border; textColor = c.label;
                        }

                        return (
                          <g key={member.id}
                            style={{ cursor:"pointer" }}
                            onMouseEnter={e => handleSeatHover(e, member)}
                            onMouseLeave={() => setTooltip(null)}
                            onClick={() => handleSeatClick(member)}
                          >
                            {/* Glow for selected */}
                            {isSelected && <circle cx={x} cy={y} r={R + 5} fill="rgba(255,255,255,0.06)" />}
                            {/* Main seat circle */}
                            <circle
                              cx={x} cy={y} r={R}
                              fill={fill}
                              stroke={isSelected ? "#ffffff" : isSwing ? "#c9a84c" : stroke}
                              strokeWidth={isSelected ? 2 : isSwing ? 1.5 : 1}
                            />
                            {/* Swing indicator dot */}
                            {isSwing && <circle cx={x + R - 2} cy={y - R + 2} r={3} fill="#c9a84c" />}
                            {/* District number */}
                            <text
                              x={x} y={y + 3.5}
                              textAnchor="middle"
                              fill={textColor}
                              fontSize={chamber === "Senate" ? "7" : "6"}
                              fontFamily="IBM Plex Mono"
                              fontWeight="600"
                            >{district}</text>
                          </g>
                        );
                      })}
                    </svg>
                  </div>

                  {/* Selected seat detail */}
                  {selectedSeat && voteMap[selectedSeat.id] && (
                    <div style={{ marginTop: "1rem", background: "var(--surface2)", border: "1px solid var(--border)", borderRadius: 10, padding: "1rem" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "0.75rem", marginBottom: "0.75rem" }}>
                        <div style={{ fontFamily: "var(--font-display)", fontSize: "1rem", fontWeight: 700, color: "var(--text)" }}>{selectedSeat.name}</div>
                        <span className={`party-chip ${selectedSeat.party}`}>{selectedSeat.party === "D" ? "Democrat" : "Republican"}</span>
                        {swingIds.has(selectedSeat.id) && <span className="swing-chip">⚡ Swing Vote</span>}
                        <div style={{ fontFamily: "var(--font-mono)", fontSize: "0.65rem", color: "var(--muted)" }}>District {selectedSeat.district} · {selectedSeat.region}</div>
                      </div>
                      {["yes", "no", "nov"].map(type => {
                        const v = voteMap[selectedSeat.id];
                        const pct = type === "yes" ? v.yesPct : type === "no" ? v.noPct : v.noVotePct;
                        const label = type === "yes" ? "YES" : type === "no" ? "NO" : "NO VOTE";
                        return (
                          <div className="tip-bar-row" key={type} style={{ marginBottom: "0.4rem" }}>
                            <span className={`tip-bar-label ${type === "nov" ? "nov" : type}`} style={{ width: 60 }}>{label}</span>
                            <div className="tip-bar-track" style={{ flex: 1, height: 8, background: "var(--surface)", borderRadius: 100, overflow: "hidden" }}>
                              <div className={`tip-bar-fill ${type === "nov" ? "nov" : type}`} style={{ width: `${pct}%`, height: "100%", borderRadius: 100 }} />
                            </div>
                            <span className={`tip-bar-pct ${type === "nov" ? "nov" : type}`} style={{ width: 36, textAlign: "right", fontFamily: "var(--font-mono)", fontSize: "0.72rem" }}>{pct}%</span>
                          </div>
                        );
                      })}
                      <div style={{ marginTop: "0.65rem", fontSize: "0.8rem", color: "var(--muted)", lineHeight: 1.55 }}>{voteMap[selectedSeat.id].reason}</div>
                    </div>
                  )}
                </div>

                {/* FULL VOTE TABLE */}
                <div className="detail-section">
                  <div className="detail-title">Full Member Vote Probabilities</div>
                  <table className="vote-table">
                    <thead>
                      <tr>
                        <th>Member</th>
                        <th>Party</th>
                        <th>District</th>
                        <th style={{ color: "#4ade80" }}>Yes %</th>
                        <th style={{ color: "#f87171" }}>No %</th>
                        <th>No Vote %</th>
                        <th>Reason</th>
                      </tr>
                    </thead>
                    <tbody>
                      {[...activeResult.votes]
                        .sort((a, b) => b.yesPct - a.yesPct)
                        .map(v => {
                          const m = members.find(x => x.id === v.id);
                          if (!m) return null;
                          return (
                            <tr key={v.id} style={swingIds.has(v.id) ? { background: "rgba(201,168,76,0.05)" } : {}}>
                              <td style={{ fontWeight: 500, color: "var(--text)" }}>
                                {m.name}
                                {swingIds.has(v.id) && <span className="swing-chip" style={{ marginLeft: 6 }}>⚡</span>}
                              </td>
                              <td><span className={`party-chip ${m.party}`}>{m.party}</span></td>
                              <td style={{ fontFamily: "var(--font-mono)", fontSize: "0.7rem", color: "var(--muted)" }}>{m.district}</td>
                              <td className="pct-yes">{v.yesPct}%</td>
                              <td className="pct-no">{v.noPct}%</td>
                              <td className="pct-nov">{v.noVotePct}%</td>
                              <td style={{ color: "var(--muted)", fontSize: "0.75rem", maxWidth: 200 }}>{v.reason}</td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>

                {/* SWING VOTES */}
                {activeResult.swingAnalysis && (
                  <div className="detail-section">
                    <div className="detail-title">⚡ Swing Vote Analysis</div>
                    <div className="detail-body"><p>{activeResult.swingAnalysis}</p></div>
                  </div>
                )}

                {/* STRATEGIC RECOMMENDATIONS */}
                {activeResult.strategicRecs?.length > 0 && (
                  <div className="detail-section">
                    <div className="detail-title">Strategic Recommendations</div>
                    <div className="detail-body">
                      <ul>{activeResult.strategicRecs.map((r, i) => <li key={i}>{r}</li>)}</ul>
                    </div>
                  </div>
                )}

                {/* CONFIDENCE */}
                {activeResult.confidenceNote && (
                  <div className="detail-section">
                    <div className="detail-title">Confidence Assessment</div>
                    <div className="detail-body"><p>{activeResult.confidenceNote}</p></div>
                  </div>
                )}

              </div>
            )}
          </div>
        </div>

        {/* HOVER TOOLTIP */}
        {tooltip && voteMap[tooltip.member.id] && (
          <div className="tooltip-overlay" style={{ left: tooltip.x + 36, top: Math.max(8, tooltip.y - 80) }}>
            <div className="tooltip">
              <div className="tip-name">{tooltip.member.name}</div>
              <div className="tip-sub">{tooltip.member.party === "D" ? "Democrat" : "Republican"} · D{tooltip.member.district} · {tooltip.member.region}</div>
              <div className="tip-bars">
                {[
                  { type: "yes", label: "YES", pct: tooltip.vote.yesPct },
                  { type: "no", label: "NO", pct: tooltip.vote.noPct },
                  { type: "nov", label: "NO VOTE", pct: tooltip.vote.noVotePct },
                ].map(({ type, label, pct }) => (
                  <div className="tip-bar-row" key={type}>
                    <span className={`tip-bar-label ${type}`}>{label}</span>
                    <div className="tip-bar-track"><div className={`tip-bar-fill ${type}`} style={{ width: `${pct}%` }} /></div>
                    <span className={`tip-bar-pct ${type}`}>{pct}%</span>
                  </div>
                ))}
              </div>
              <div className="tip-reason">{tooltip.vote.reason}</div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
